export class ProductionRandomGateway {
    randomIntegerOnRange(startingNumber, endingNumber) {
        startingNumber = Math.ceil(startingNumber);
        endingNumber = Math.floor(endingNumber);
        return Promise.resolve(Math.floor(Math.random() * (endingNumber - startingNumber + 1)) + startingNumber);
    }
}
